import React from 'react';
import { clsx } from 'clsx';

import styles from './Button.module.scss';

export interface IButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>{
    text?: string;
    disabled?: boolean;
    wrapperClass?: string;
    buttonClass?: string;
}

export const Button = ({children, text, disabled, wrapperClass, buttonClass, ...props}: IButtonProps) => {
    return (
        <div className={clsx(wrapperClass && wrapperClass, disabled && styles.disabled)}>
            <button className={clsx(styles.button, buttonClass && buttonClass)} disabled={disabled} {...props}>
                {children}
                {text && <span className={styles.buttonText}>{text}</span>}
            </button>
        </div>
    );
};
